export default (event, args = {}) => {
  return {
    created() {
      this.$eventBus.$on("onboarding:reset", this.emitOnboardingEvent);
    },

    beforeDestroy() {
      this.$eventBus.$off("onboarding:reset", this.emitOnboardingEvent);
    },

    methods: {
      emitOnboardingEvent() {
        this.$eventBus.$emit(event, args);
      },
    },
  };
};
